import { Component, Input } from '@angular/core';
import { Patient } from '../../../models/patient';
import { ALaDateDuPipe } from '../../../pipes/a-la-date-du.pipe';
import { PressionPipe } from '../../../pipes/pression.pipe';
import { TraitementDataComponent } from '../traitement-data/traitement-data.component';

@Component({
  selector: 'app-traitement-data-pression-auto',
  standalone: true,
  imports: [
    TraitementDataComponent,
    PressionPipe,
    ALaDateDuPipe],
  templateUrl: './traitement-data-pression-auto.component.html',
  styleUrl: './traitement-data-pression-auto.component.scss'
})
export class TraitementDataPressionAutoComponent {
  @Input() patient: Patient | undefined;
}
